module.exports = __webpack_public_path__ + "static/img/faq-green.b87a6e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/faq-green.svg
// module id = 287
// module chunks = 2